<p>
  <strong class="gauge-title">
    <slot name="title">
      {{ title }}
    </slot>
  </strong>
</p>
<svg class="gauge" [attr.viewBox]="viewBox">
  <g class="gauge-arcs">
    <path gpeiGaugeArc
      class="gauge-background"
      [startAngle]="startAngle"
      [endAngle]="endAngle"
      [innerRadius]="innerRadius"
      [outerRadius]="outerRadius">
    </path>
    <g class="gauge-sections">
      <path gpeiGaugeArc
        *ngFor="let section of sections"
        class="gauge-section"
        [startAngle]="section.startAngle"
        [endAngle]="section.endAngle"
        [innerRadius]="innerRadius"
        [outerRadius]="outerRadius"
        [ngClass]="section.class"
        [style]="section.style">
      </path>
    </g>
    <path gpeiGaugeArc
      *ngIf="valueArc && (!sections || sections.length === 0)"
      class="gauge-value"
      [startAngle]="startAngle"
      [endAngle]="valueAngle"
      [innerRadius]="innerRadius"
      [outerRadius]="outerRadius">
    </path>
  </g>
  <g *ngIf="labels && (!sections || sections.length === 0)" class="gauge-labels">
    <text gpeiGaugeLabel id="min-label" [angle]="this.startAngle" [radius]="this.outerRadius + 4">{{ min }}</text>
    <text gpeiGaugeLabel id="value-label" [angle]="this.valueAngle" [radius]="this.outerRadius + 4">{{ value }}</text>
    <text gpeiGaugeLabel id="max-label" [angle]="this.endAngle" [radius]="this.outerRadius + 4">{{ max }}</text>
  </g>
  <g gpeiGaugeNeedle
    *ngIf="needle"
    class="gauge-needle"
    [startWidth]="needleStartWidth"
    [endWidth]="needleEndWidth"
    [length]="needleLength"
    [angle]="valueAngle">
  </g>
</svg>
